import * as React from 'react';
import { Input } from "reactstrap";
import moment, { utc } from 'moment';

interface IProps {
	value: any;
	options?: any;
	onChange?: any;
	id: string;
	type?: any;
	className?: string;
	isRequired?: boolean;
	onBlur?: any;
	isHover?: boolean;
	disabled?: boolean;
}

interface IState {
	hoverClass: string
}

class DABDropDown extends React.Component<IProps, IState>  {
	state = { hoverClass: "" };
	constructor(props: any) {
		super(props);
		this.state = {
			hoverClass: this.props.isHover ? " label-edit " : ""
		}
		this.handleOnChange = this.handleOnChange.bind(this);
	}

	handleOnChange(event) {
		if (this.props.onChange) {
			this.props.onChange(event);
		}
	}

	render() {
		return (
			<Input
				type="select"
				className={"form-select "
					+ this.state.hoverClass + " "
					+ (this.props.className ? this.props.className : "")}
				id={this.props.id} name={this.props.id}
				required={this.props.isRequired}
				disabled={this.props.disabled}
				value={this.props.value}
				key={'key' + this.props.id}
				onChange={(event) => { this.handleOnChange(event) }}>
				{
					this.props.options && this.props.options.map((data) =>
						<option key={data.text} value={data.value} disabled={data?.disabled}>{data.text}</option>
					)}
			</Input>)
	}
}

export default DABDropDown;
